import React from 'react'
import PgaCoachSearch from './pga-coach-search'

function PgaCoachProgramsPage(props) {
  return <PgaCoachSearch {...props} />
}

export default PgaCoachProgramsPage
